export default __webpack_public_path__ + "static/media/ksivalue_big.327d38e5.jpg";